module.exports = __webpack_public_path__ + "img/car-logo-descricao.65ba792f.jpg";